import React from 'react'
import {
  Control,
  FieldValues,
  UseFormSetValue,
  Path,
  Controller
} from 'react-hook-form'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Switch,
  Textfield
} from '@clientbase/clientbase-library'
import { Grid, Typography } from '@mui/material'

import NumberFormatCustom from 'components/PorcentageInput/PorcentageInput'

export interface FeesProps<T extends FieldValues> {
  control: Control<T, object>
  setValue?: UseFormSetValue<T>
}

const Fees = <T extends FieldValues>({ control, setValue }: FeesProps<T>) => {
  return (
    <Controller
      control={control}
      name={'interestPolicy' as Path<T>}
      render={({ field }) => (
        <Accordion
          expanded={field.value}
          onChange={(_, expanded) =>
            !!setValue && setValue('interestPolicy' as Path<T>, expanded as any)
          }
          sx={{
            border: '1px solid #E8EBE8',
            borderLeft: '3px solid',
            borderLeftColor: 'primary.main',
            borderRadius: '8px !important',
            backgroundColor: '#FAFBFA',
            boxShadow: 'none',
            '&:before': { display: 'none' },
            '&.Mui-expanded': {
              margin: 0,
              backgroundColor: '#fff'
            }
          }}
        >
          <AccordionSummary
            hasSwitch
            expandIcon={<Switch checked={field.value} {...field} />}
          >
            <Typography variant="smBold">Juros</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 2 }}>
            <Grid container={true} rowSpacing={1} columnSpacing={2}>
              <Grid item={true} xs={12} sm={12} lg={6}>
                <Controller
                  control={control}
                  name={'interestFine' as Path<T>}
                  render={({
                    field: { value, ref, ...field },
                    fieldState: { error }
                  }) => (
                    <Textfield
                      inputRef={ref}
                      label="Valor da multa de mora?"
                      placeholder="2.0%"
                      value={value}
                      InputProps={{
                        inputComponent: NumberFormatCustom as any,
                        sx: {
                          fontSize: '14px'
                        }
                      }}
                      helperText={error?.message}
                      error={!!error?.message}
                      {...field}
                    />
                  )}
                />
              </Grid>
              <Grid item={true} xs={12} sm={12} lg={6}>
                <Controller
                  control={control}
                  name={'interestFee' as Path<T>}
                  render={({
                    field: { value, ref, ...field },
                    fieldState: { error }
                  }) => (
                    <Textfield
                      label="Valor do juros de mora?"
                      placeholder="1.0%"
                      inputRef={ref}
                      value={value}
                      InputProps={{
                        inputComponent: NumberFormatCustom as any,
                        inputProps: { isAm: true },
                        sx: {
                          fontSize: '14px'
                        }
                      }}
                      helperText={error?.message}
                      error={!!error?.message}
                      {...field}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      )}
    />
  )
}

export default Fees
